// 积分交易记录 API 服务
const API_BASE = '/api/v2/points';

const pointsApi = {
  /**
   * 获取用户积分余额
   * @param {string} userId - 用户ID
   * @returns {Promise<{success: boolean, data?: {balance: number}, message?: string}>}
   */
  getBalance: async (userId) => {
    try {
      const response = await fetch(`${API_BASE}/balance?user_id=${userId}`);
      return await response.json();
    } catch (error) {
      console.error('获取积分余额失败:', error);
      return { success: false, message: error.message };
    }
  },

  /**
   * 获取用户积分汇总信息
   * @param {string} userId - 用户ID
   * @returns {Promise<{success: boolean, data?: Object, message?: string}>}
   */
  getSummary: async (userId) => {
    try {
      const response = await fetch(`${API_BASE}/summary?user_id=${userId}`);
      return await response.json();
    } catch (error) {
      console.error('获取积分汇总失败:', error);
      return { success: false, message: error.message };
    }
  },

  /**
   * 获取用户积分交易记录
   * @param {string} userId - 用户ID
   * @param {string|null} type - 交易类型 earn/spend (可选)
   * @param {number} page - 页码 (可选，默认1)
   * @param {number} pageSize - 每页数量 (可选，默认20)
   * @returns {Promise<{success: boolean, data?: {list: Array, total: number, page: number, page_size: number, total_pages: number}, message?: string}>}
   */
  getTransactions: async (userId, type = null, page = 1, pageSize = 20) => {
    try {
      const params = new URLSearchParams({
        user_id: userId,
        page,
        page_size: pageSize
      });
      if (type) {
        params.append('type', type);
      }

      const response = await fetch(`${API_BASE}/transactions?${params}`);
      return await response.json();
    } catch (error) {
      console.error('获取积分交易记录失败:', error);
      return { success: false, message: error.message };
    }
  },

  /**
   * 增加积分
   * @param {string} userId - 用户ID
   * @param {number} amount - 积分数量
   * @param {string} source - 来源
   * @param {string} description - 描述 (可选)
   * @param {number} growthValue - 成长值 (可选)
   * @returns {Promise<{success: boolean, data?: Object, message?: string}>}
   */
  earnPoints: async (userId, amount, source, description = '', growthValue = 0) => {
    try {
      const response = await fetch(`${API_BASE}/earn`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          user_id: userId,
          amount,
          source,
          description,
          growth_value: growthValue
        })
      });
      return await response.json();
    } catch (error) {
      console.error('增加积分失败:', error);
      return { success: false, message: error.message };
    }
  },

  /**
   * 消耗积分
   * @param {string} userId - 用户ID
   * @param {number} amount - 积分数量
   * @param {string} source - 来源
   * @param {string} description - 描述 (可选)
   * @returns {Promise<{success: boolean, data?: Object, message?: string}>}
   */
  spendPoints: async (userId, amount, source, description = '') => {
    try {
      const response = await fetch(`${API_BASE}/spend`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          user_id: userId,
          amount,
          source,
          description
        })
      });
      return await response.json();
    } catch (error) {
      console.error('消耗积分失败:', error);
      return { success: false, message: error.message };
    }
  },

  /**
   * 根据交易号获取交易记录
   * @param {string} transactionNo - 交易号
   * @returns {Promise<{success: boolean, data?: Object, message?: string}>}
   */
  getTransaction: async (transactionNo) => {
    try {
      const response = await fetch(`${API_BASE}/transaction/${transactionNo}`);
      return await response.json();
    } catch (error) {
      console.error('获取交易记录失败:', error);
      return { success: false, message: error.message };
    }
  }
};

// 积分来源描述映射
export const POINT_SOURCE_MAP = {
  lottery: '彩票兑换',
  watch: '观看奖励',
  signin: '每日签到',
  recharge: '积分充值',
  redeem: '积分兑换',
  invite: '邀请奖励',
  comment: '评论奖励',
  share: '分享奖励',
  favorite: '收藏奖励',
  activity: '活动奖励',
  other: '其他'
};

// 积分类型映射
export const POINT_TYPE_MAP = {
  earn: '赚取',
  spend: '消耗'
};

export default pointsApi;
